module.exports = __webpack_public_path__ + "img/notebook-pen.e587e8a7.svg";